import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSession } from "Contexts/SessionContext";

const SessionUrlSync = ({ children }) => {
  const { sessionCode } = useSession();
  const navigate = useNavigate();
  const location = useLocation();
  const previousSessionCode = useRef(null);

  useEffect(() => {
    if (!sessionCode) return;

    const currentParams = new URLSearchParams(location.search);
    const urlSessionCode = currentParams.get("session");

    const sessionJustCreated =
      previousSessionCode.current === null && sessionCode !== null;
    const sessionMismatch = urlSessionCode !== sessionCode;

    if (sessionJustCreated || sessionMismatch) {
      currentParams.set("session", sessionCode);
      const newUrl = `${location.pathname}?${currentParams.toString()}`;
      navigate(newUrl, { replace: true });
    }

    previousSessionCode.current = sessionCode;
  }, [sessionCode, location.pathname, location.search, navigate]);

  return children;
};

export default SessionUrlSync;
